import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ShinyText from '../ShinyText';

export default function ContactUsSection() {
  const [hovered, setHovered] = useState(false);

  return (
    <section className="font-sans py-16 md:pt-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col md:flex-row gap-12">
        {/* Left Side: Contact Details */}
        <div className="flex-1 flex flex-col justify-center">
          <br />
          <br />
          <br />

          <h1 className="text-5xl md:text-7xl font-bold text-black mb-8">
            Contact Us
          </h1>

          <p className="text-2xl md:text-3xl text-black mb-10 max-w-2xl">
            We’d love to hear from you—whether you’re hiring, job seeking, or just exploring options.
          </p>

          {/* Offices */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-lg text-black">
            {/* Dubai */}
            <div>
              <h3 className="font-semibold text-xl mb-1">Dubai Office</h3>
              <p className="leading-relaxed">
                Reef Tower, <br />
                Jumeirah Lake Tower, Cluster O <br />
                Dubai, UAE
              </p>
              <p className="mt-1">Tel: +971 (0)452 94626</p>
            </div>

            {/* London */}
            <div>
              <h3 className="font-semibold text-xl mb-1">London Office</h3>
              <p className="leading-relaxed">
                16 Great Queen Street, <br />
                Covent Garden, <br />
                London, United Kingdom <br />
                WC2B 5AH
              </p>
              <p className="mt-1">Tel: +44 (0)208 308 9364</p>
            </div>

            {/* New York */}
            <div>
              <h3 className="font-semibold text-xl mb-1">New York Office</h3>
              <p className="leading-relaxed">
                1 Little W 12th St, <br />
                New York, NY 10014, <br />
                United States
              </p>
              <p className="mt-1">Tel: +1 (0)845 409 0628</p>
            </div>
          </div>

          {/* Email + Social */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-10 text-lg text-black">
            <div>
              <h3 className="font-semibold text-xl mb-1">Email</h3>
              <p>info@lincolnlaim.com</p>
            </div>
            <div>
              <h3 className="font-semibold text-xl mb-2">Social Network</h3>
              <a
                href="https://www.linkedin.com/company/lincoln-aim"
                className="inline-flex items-center gap-2 text-neutral-700 hover:text-black transition"
              >
                <img
                  src="/images/LinkedInIcon.svg"
                  alt="LinkedIn"
                  className="w-6 h-6 grayscale hover:grayscale-0"
                />
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="flex-1 flex items-center">
          <div
            className="
              w-full
              bg-white
              rounded-2xl
              p-8 md:p-12
              border border-gray-200
              shadow-[0_24px_48px_rgba(0,0,0,0.06)]
              md:pt-10
            "
          >
            <h2 className="text-3xl font-bold text-black mb-2">Get In Touch</h2>
            <p className="text-lg text-black mb-8">
              Connect with our team in Dubai, London, or New York — we’re here to help, wherever you are.
            </p>

            <form className="flex flex-col gap-6">
              <div>
                <label htmlFor="fullname" className="block text-base font-medium mb-1 text-black">
                  Full name
                </label>
                <input
                  id="fullname"
                  name="fullname"
                  type="text"
                  className="w-full border-b border-gray-400 bg-transparent py-2 px-0 focus:outline-none focus:border-black text-lg text-black placeholder-gray-500"
                  autoComplete="name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-base font-medium mb-1 text-black">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="w-full border-b border-gray-400 bg-transparent py-2 px-0 focus:outline-none focus:border-black text-lg text-black placeholder-gray-500"
                  autoComplete="email"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-base font-medium mb-1 text-black">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={3}
                  className="w-full border-b border-gray-400 bg-transparent py-2 px-0 focus:outline-none focus:border-black text-lg text-black placeholder-gray-500 resize-none"
                />
              </div>

              <motion.a
                href="#"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                whileHover={{
                  scale: 1.05,
                  backgroundColor: '#111',
                  color: '#fff'
                }}
                whileTap={{ scale: 0.96 }}
                transition={{ type: 'spring', stiffness: 300 }}
                className="flex items-center px-6 py-2 border-2 border-black rounded-full text-base font-medium group w-max mt-4"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                <ShinyText
                  text="Send a Message"
                  disabled={!hovered}
                  className={!hovered ? 'text-black' : ''}
                />
                <motion.svg
                  className="ml-2 w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  whileHover={{ x: 4 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </motion.svg>
              </motion.a>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
